<div class="background" [ngStyle]="{ 'background-image': url }"></div>
<div class="content">
  <ng-content></ng-content>
</div>
